import { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { getUserAndPlanDetails } from "../../../actions/subscriptionActions";
import {
  getStaffs,
  inviteStaff,
  softDeleteStaff,
} from "../../../actions/staffActions";
import Loader from "../../../components/Loader/Loader";
import {
  SET_SUBSCRIPTION_STAFF,
  SET_SUBSCRIPTION_USER_PAGINATION,
  SET_IS_LOADING,
} from "../../../actions/types";
import SubscriptionPlans from "./subscription-plans";
import PurchaseHistory from "./purchase-history";
import ManageInviteUser from "./manage-invite-user";
import SMSCreditsTab from "./sms-credits-tab";
import SMSDestinationsTab from "./sms-destinations-tab";
import SMSBalanceTab from "./sms-balance-tab";
import { getAdminBusinessId } from "../../../utils/authHelper";
import { notification } from "../../../utils/utility";
import StaffHasBookingModal from "../../admin/settings/Staff/StaffHasBookingModal";
import Tooltip from "../../../components/Tooltip";
import PageHeader from "../../../components/PageHeader/PageHeader";
import { fetchUserFeatures } from "../../../actions/featureAccessActions";
import { isSmsAllowed } from "../../../utils/trialAccess";

const TABS = {
  plans: "plans",
  sms: "sms",
  destinations: "destinations",
  balance: "balance",
};

const Subscription = (props) => {
  const [showStaffHasBookings, setShowStaffHasBookings] = useState(false);
  const [activeTab, setActiveTab] = useState(TABS.plans);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: SET_IS_LOADING,
      payload: true,
    });
    loadStaffs({
      ...props.subscription.pagination,
      sortField: "id",
      sortOrder: "desc",
    });
    getUserAndPlans();
  }, []);

  /**
   * Get user and Plan
   */
  const getUserAndPlans = () => {
    const { getUserAndPlanDetails } = props;
    getUserAndPlanDetails({
      onSuccess: () => {
        dispatch(fetchUserFeatures());
        dispatch({
          type: SET_IS_LOADING,
          payload: false,
        });
      },
      onError: (error) => {
        console.log("error", error);
        dispatch({
          type: SET_IS_LOADING,
          payload: false,
        });
      },
    });
  };

  /**
   * on invitee staff
   * @param {*} data
   */
  const onInviteStaff = (data) => {
    const { inviteStaff } = props;

    dispatch({
      type: SET_IS_LOADING,
      payload: true,
    });

    inviteStaff({
      data: {
        ...data,
        business_id: getAdminBusinessId(),
      },
      onSuccess: function (details) {
        dispatch({
          type: SET_IS_LOADING,
          payload: false,
        });
        loadStaffs({
          ...props.subscription.pagination,
          pageNumber: 1,
          sortField: "id",
          sortOrder: "desc",
        });
        notification.success("Staff Invited successfully");
        // _this.reloadPage();
      },
      onError: function (error) {
        notification.error(
          error ? error : "An error occured during invitation, please try later"
        );
        dispatch({
          type: SET_IS_LOADING,
          payload: false,
        });
      },
    });
  };

  /**
   * delete staff
   * @param {*} staffId
   */
  const onDeleteStaff = (staffId) => {
    const { softDeleteStaff } = props;
    dispatch({
      type: SET_IS_LOADING,
      payload: true,
    });
    softDeleteStaff({
      data: {
        id: staffId,
      },
      onSuccess: function () {
        dispatch({
          type: SET_SUBSCRIPTION_USER_PAGINATION,
          payload: {
            pageNumber: 1,
            pageSize: props.subscription.pagination.pageSize,
          },
        });
        loadStaffs({
          ...props.subscription.pagination,
          pageNumber: 1,
          sortField: "id",
          sortOrder: "desc",
        });
        notification.success(`Staff successfully deleted`);
      },
      onError: function (error) {
        const { data } = error.response;
        if (parseInt(data.code) === 255) {
          setShowStaffHasBookings(true);
        } else {
          notification.error(
            "An Error occurred during delete, please try later"
          );
        }

        dispatch({
          type: SET_IS_LOADING,
          payload: false,
        });
      },
    });
  };

  /**
   * Load staffs
   * @param {*} data
   */
  const loadStaffs = (data) => {
    const { getStaffs } = props;
    dispatch({
      type: SET_IS_LOADING,
      payload: true,
    });
    getStaffs({
      data,
      onSuccess: function (details) {
        dispatch({
          type: SET_SUBSCRIPTION_STAFF,
          payload: {
            staffs: details.entity,
            totalStaffs: details.totalCount,
          },
        });
        dispatch({
          type: SET_IS_LOADING,
          payload: false,
        });
      },
      onError: function (error) {
        console.log(error);
        dispatch({
          type: SET_IS_LOADING,
          payload: false,
        });
      },
    });
  };

  /**
   * on page change
   * @param {*} pageNumber
   * @param {*} pageSize
   */
  const onPageChange = (pageNumber, pageSize) => {
    dispatch({
      type: SET_IS_LOADING,
      payload: true,
    });
    dispatch({
      type: SET_SUBSCRIPTION_USER_PAGINATION,
      payload: {
        pageNumber,
        pageSize,
      },
    });
    loadStaffs({
      pageSize,
      pageNumber,
      sortField: "id",
      sortOrder: "desc",
    });
  };

  const smsUnlocked = isSmsAllowed(
    props.subscription?.userPlan,
    props.featureAccess
  );

  return (
    <section className="admin-page">
      <Loader isShowLoader={props.layout.isLoading} />
      <PageHeader
        title="Manage Subscriptions"
        subtitle="Choose a plan and manage your team members."
      />
      <div className="eventdetailsaddbox rd_noshadow">
        <div className="filter_bar dark">
          <ul className="cus_tab">
            <li>
              <button
                type="button"
                className={`btn${activeTab === TABS.plans ? " active" : ""}`}
                onClick={() => setActiveTab(TABS.plans)}
              >
                Subscription Plans <Tooltip code="P14F1" />
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`btn${activeTab === TABS.sms ? " active" : ""}`}
                onClick={() => setActiveTab(TABS.sms)}
              >
                SMS Credits
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`btn${activeTab === TABS.destinations ? " active" : ""}`}
                onClick={() => setActiveTab(TABS.destinations)}
              >
                SMS Destinations
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`btn${activeTab === TABS.balance ? " active" : ""}`}
                onClick={() => setActiveTab(TABS.balance)}
              >
                SMS Balance
              </button>
            </li>
          </ul>
        </div>

        {activeTab === TABS.plans && (
          <>
            <SubscriptionPlans getUserAndPlans={getUserAndPlans} />
            <PurchaseHistory />
            <ManageInviteUser
              onPageChange={onPageChange}
              onInviteStaff={onInviteStaff}
              onDeleteStaff={onDeleteStaff}
              getUserAndPlans={getUserAndPlans}
            />
          </>
        )}

        {activeTab === TABS.sms && (
          smsUnlocked ? (
            <SMSCreditsTab />
          ) : (
            <p className="p-4 mb-0">SMS is available after you subscribe.</p>
          )
        )}
        {activeTab === TABS.destinations && (
          smsUnlocked ? (
            <SMSDestinationsTab />
          ) : (
            <p className="p-4 mb-0">SMS is available after you subscribe.</p>
          )
        )}
        {activeTab === TABS.balance && (
          smsUnlocked ? (
            <SMSBalanceTab />
          ) : (
            <p className="p-4 mb-0">SMS is available after you subscribe.</p>
          )
        )}
      </div>
      {showStaffHasBookings && (
        <StaffHasBookingModal
          showStaffHasBookings={showStaffHasBookings}
          toggle={() => setShowStaffHasBookings(false)}
        />
      )}
    </section>
  );
};

const mapStateToProps = (state) => ({
  subscription: state.subscription,
  layout: state.layout,
  featureAccess: state.featureAccess,
});

export default connect(mapStateToProps, {
  getUserAndPlanDetails,
  getStaffs,
  inviteStaff,
  softDeleteStaff,
})(Subscription);
